import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-submits-on-changed]';
const PLUGIN_NAME = 'SubmitsOnChanged';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--submits-on-changed" */ './submits-on-changed'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
           
		});
	});
    
    $(document).on('filter-groups-loaded', function(){
        $(ELEMENT_SELECTOR).each(function() {
            const element = this;
            System.import(
                /* webpackChunkName: "plugin--submits-on-changed" */ './submits-on-changed'
            ).then((module) => {
                plugin(PLUGIN_NAME, module.default);
                $(element)[PLUGIN_NAME]();
               
            });
        });
    });
});



// WEBPACK FOOTER //
// ./client/src/core/components/submits-on-changed/index.js